import { doc, runTransaction, getFirestore } from "firebase/firestore";

const db = getFirestore();

export const generateInvoiceNumber = async (): Promise<string> => {
  const counterRef = doc(db, "counters", "invoiceNumber");

  const invoiceNumber = await runTransaction(db, async (transaction) => {
    const counterSnap = await transaction.get(counterRef);
    const current = counterSnap.exists() ? counterSnap.data().current : 0;
    const next = current + 1;

    transaction.set(counterRef, { current: next }, { merge: true });

    return `ICA-${next.toString().padStart(5, "0")}`; // ICA-00001, etc.
  });

  return invoiceNumber;
};
